const PaginationComponent = ({ totalPages, activePage, searchData, loading=false }) => {

  const previousPage = () => {
    searchData(
      activePage - 1
    );
  }
  const nextPage = () => {
    searchData(
      activePage + 1
    );
  }  

  const renderPagination = () => {
    const paginationItems = [];

    let startPage = Math.max(activePage - 2, 1);
    let endPage = Math.min(startPage + 4, totalPages);

    if (endPage - startPage < 4) {
      startPage = Math.max(endPage - 4, 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      const isActive = i === activePage;
      paginationItems.push(
        <li key={i} className={`page-item ${isActive && !loading ? "active" : ""}`}>
          <button className={`page-link ${loading ? "disabled" : ""}`} style={{ cursor: "pointer" }} onClick={() => searchData(i)}>
            {i}
          </button>
        </li>
      );
    }

    return paginationItems;
  };

  return (
    <>
    {totalPages > 1 && <div className="row mt-3">
      <div className="col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start"></div>
      <div className="col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end">
        <div id="kt_table_users_paginate">
          <ul className="pagination">
            <li className={`page-item previous ${loading ? "disabled" : ""} ${activePage === 1 ? "disabled" : ""}`}>
              <button className="page-link page-text me-5" style={{ cursor: "pointer" }} onClick={() => previousPage()}>
                Anterior
              </button>
            </li>
            {Math.max(activePage - 2, 1) > 1 && (
              <>
                <li className={`page-item ${activePage === 1 && !loading ? "active" : ""}`}>
                  <button className={`page-link ${loading ? "disabled" : ""}`} style={{ cursor: "pointer" }} onClick={() => searchData(1)}>
                    1
                  </button>
                </li>
                <li className="page-item disabled"><span className="page-link">...</span></li>
              </>
            )}
            {renderPagination()}
            {Math.min(Math.max(activePage - 2, 1) + 4, totalPages) < totalPages && (
              <>
                <li className="page-item disabled"><span className="page-link">...</span></li>
                <li className={`page-item ${activePage === totalPages && !loading ? "active" : ""}`}>
                  <button className={`page-link ${loading ? "disabled" : ""}`} style={{ cursor: "pointer" }} onClick={() => searchData(totalPages)}>
                    {totalPages}
                  </button>
                </li>
              </>
            )}
            <li className={`page-item next ${loading ? "disabled" : ""} ${totalPages === activePage ? "disabled" : ""}`}>
              <button className="page-link page-text" style={{ cursor: "pointer" }} onClick={() => nextPage()}>
                Próxima
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>}
    </>
  );
};

export default PaginationComponent;